import { useRef } from 'react';
import { useForm } from 'react-final-form';

const normalize = (value: string | number | undefined) =>
  value != null ? String(value) : '';

export const useFilterChangeSubmit = (
  fromValue: string | number | undefined,
  toValue: string | number | undefined,
  submitOnChange: boolean
) => {
  const { submit } = useForm();

  const initialFromRef = useRef(normalize(fromValue));
  const initialToRef = useRef(normalize(toValue));

  const handleClose = () => {
    const currentFrom = normalize(fromValue);
    const currentTo = normalize(toValue);

    const isChanged =
      currentFrom !== normalize(initialFromRef.current) ||
      currentTo !== normalize(initialToRef.current);

    if (submitOnChange && isChanged) {
      submit();
      initialFromRef.current = currentFrom;
      initialToRef.current = currentTo;
    }
  };

  return { handleClose };
};
